import { useState, useRef, useEffect } from 'react';

function useHover(hideOnScroll) {
  var _useState = useState(false),
      value = _useState[0],
      setValue = _useState[1];

  var isTouch = useRef(false);
  var holdTimeOut = useRef(0);
  var ref = useRef(null);

  var handleMouseEnter = function handleMouseEnter() {
    if (!isTouch.current) {
      setValue(true);
    }

    isTouch.current = false;
  };

  var handleMouseLeave = function handleMouseLeave() {
    setValue(false);
    clearTimeout(holdTimeOut.current);
  };

  var handleTouchStart = function handleTouchStart() {
    isTouch.current = true;
    clearTimeout(holdTimeOut.current);
    holdTimeOut.current = window.setTimeout(function () {
      setValue(true);
      isTouch.current = false;
    }, 350);
  };

  var handleTouchEnd = function handleTouchEnd() {
    setValue(false);
    clearTimeout(holdTimeOut.current);
  };

  var handleScroll = function handleScroll() {
    setValue(false);
    clearTimeout(holdTimeOut.current);
  };

  useEffect(function () {
    var node = ref.current;

    if (node) {
      node.addEventListener("mouseenter", handleMouseEnter);
      node.addEventListener("mouseleave", handleMouseLeave);
      node.addEventListener("touchstart", handleTouchStart);
      node.addEventListener("touchend", handleTouchEnd);
      hideOnScroll && document.addEventListener("scroll", handleScroll, {
        capture: true
      });
    }

    return function () {
      clearTimeout(holdTimeOut.current);
      node == null ? void 0 : node.removeEventListener("mouseenter", handleMouseEnter);
      node == null ? void 0 : node.removeEventListener("mouseleave", handleMouseLeave);
      node == null ? void 0 : node.removeEventListener("touchstart", handleTouchStart);
      node == null ? void 0 : node.removeEventListener("touchend", handleTouchEnd);
      document.removeEventListener("scroll", handleScroll);
    };
  }, [ref, hideOnScroll]);
  return [ref, value];
}

export { useHover };